module.exports = __webpack_public_path__ + "static/media/forgotPass1.d064284a.svg";